export default __webpack_public_path__ + "static/media/devops.47ee8354.png";